export default "__VITE_ASSET__BvfKhn2l__"